import { render, staticRenderFns } from "./MultiplyQuiz.vue?vue&type=template&id=00a37f46&scoped=true&"
import script from "./MultiplyQuiz.vue?vue&type=script&lang=ts&"
export * from "./MultiplyQuiz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a37f46",
  null
  
)

export default component.exports